export default __webpack_public_path__ + "static/media/business-10.4a7fc91c.jpg";